<template>
  <AModal modal-class="d-comment-entry-removal">
    <div class="overlay" />

    <div class="modal-content">
      <div class="modal-header">
        <h4>Delete comment?</h4>
        <a
          class="button button-yellow button-icon button-close-white button-close-modal"
          @click="dismiss"
        />
      </div>

      <div
        class="modal-body loadable"
        :class="{ 'loading': isProcessing }"
      >
        <div
          v-if="isProcessing"
          class="loading-content"
        >
          <DuiLoadingIndicator size="lg" />
          <p class="space-top-2em">
            Removing comment...
          </p>
        </div>

        <div class="loaded-content">
          <p class="space-bottom-2em">
            Please confirm that you would like to remove
            this comment. Once removed, you won't be able
            to get it back!
          </p>

          <div class="button-pair right space-top-3em">
            <button
              :disabled="isProcessing"
              type="button"
              @click="dismiss"
            >
              Cancel
            </button>
            <button
              class="button-yellow"
              :disabled="isProcessing"
              type="button"
              @click="deleteComment"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </AModal>
</template>

<script>
import Vue from 'vue';

import AModal from '@d-components/a-modal/a-modal.vue';
import commentsService from '@d-services/comments-service/comments-service';
import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  components: {
    AModal,
  },
  props: {
    comment: {
      type: Object,
      required: true,
    },
    itemSlug: {
      type: String,
      required: true,
    },
    itemType: {
      type: String,
      validator: function (value) {
        return [
          'book',
          'post',
          'user-review',
        ].indexOf(value) !== -1;
      },
      required: true,
    },
  },
  data: () => ({
    isProcessing: false,
  }),
  methods: {
    async deleteComment() {
      this.isProcessing = true;

      try {
        switch(this.itemType) {
          case 'book':
            await commentsService.deleteBookComment(this.itemSlug, this.comment.id);
            break;
          case 'post':
            await commentsService.deletePostComment(this.itemSlug, this.comment.id);
            break;
          case 'user-review':
            await commentsService.deleteUserReviewComment(this.itemSlug, this.comment.id);
            break;
        }

        Vue.duiNotificationManager.success('Comment removed.');
        this.$emit('comment-removed', this.comment);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.isProcessing = false;
    },

    dismiss() {
      this.$emit('dismiss');
    },
  },
};
</script>
